import PositionJobPostingVO from '@domain/vo/common/PositionJobPostingVO';
import { RecruitCategoryType, RecruitCategoryTypeNameMap } from '@domain/constant/recruitCategoryType';
import NumberFormat from '@utils/number/format';
import DateFormat from '@utils/date/format';

export interface IPositionBookmarkListItemVO {
  sn: number; //포지션 sn
  title: string; //포지션명
  companyName: string; //기업명
  locationCode: number; //지역코드
  logoImageUrl: string; //로고 이미지 url
  teamImageUrl: string; //팀 이미지 url
  recruitmentType: RecruitCategoryType;
  jobGroupName?: string;
  jobTitleNames: string[]; //직무명
  bookmarkYn?: boolean; //북마크 여부
  minSalary: number | null; //최소 연봉
  maxSalary: number | null; //최대 연봉
  closingDateTime: string | null; // 마감기간
  matchingYn?: boolean; // 매칭 받음 여부
  jobPosting: PositionJobPostingVO | null; // 포지션이 속한 채용 공고 정보
}

export class PositionBookmarkListItemVO {
  sn: number;
  title: string;
  companyName: string;
  locationName: string;
  logoImageUrl: string;
  teamImageUrl: string;
  recruitment: string;
  jobGroupName: string;
  jobTitleNames: string[];
  jobTitleNameText: string;
  bookmarkYn: boolean;
  salary: string;
  closingDateText: string;
  subInfoTextList: string[][];
  matchingYn: boolean;
  jobPosting: PositionJobPostingVO | null; // 포지션이 속한 채용 공고 정보

  constructor(dto: IPositionBookmarkListItemVO) {
    this.sn = dto.sn;
    this.title = dto.title;
    this.companyName = dto.companyName;
    this.locationName = NumberFormat.formatLocationName(dto.locationCode);
    this.logoImageUrl = dto.logoImageUrl;
    this.teamImageUrl = dto.teamImageUrl;
    this.recruitment = this.getTagText(RecruitCategoryTypeNameMap[dto.recruitmentType]);

    this.jobGroupName = dto.jobGroupName ? this.getTagText(dto.jobGroupName) : '';
    this.jobTitleNames = dto.jobTitleNames;
    this.jobTitleNameText = this.getJobTitleNameText(dto.jobTitleNames);
    this.bookmarkYn = dto.bookmarkYn ?? false;
    this.salary = NumberFormat.formatPositionSalaryText(dto.minSalary, dto.maxSalary);
    this.closingDateText = DateFormat.formatPositionClosingDateText(dto.closingDateTime);
    this.subInfoTextList = this.getSubInfoTextList();
    this.matchingYn = dto.matchingYn ?? false;
    this.jobPosting = dto.jobPosting;
  }

  private getTagText(tag?: string) {
    if (!tag) return '';
    return `#${tag}`;
  }

  private getJobTitleNameText(jobTitleNames: string[]) {
    if (jobTitleNames.length < 1) return '';
    if (jobTitleNames.length === 1) return `#${jobTitleNames[0]}`;

    return `#${jobTitleNames[0]}+${jobTitleNames.length - 1}`;
  }

  private getSubInfoTextList(): string[][] {
    if (this.jobTitleNames.length) {
      return [
        [this.recruitment, this.jobTitleNameText, this.closingDateText], //line1
        [this.salary], //line2
      ];
    }

    return [
      [this.recruitment, this.jobGroupName, this.closingDateText], //line1
      [this.salary], //line2
    ];
  }
}
